const BannerStyle = {
    base: "fixed top-0 left-0 w-full h-10 z-[10] text-white flex gap-2 font-semibold justify-center items-center",
    blue: "bg-blue-400",
    green: "bg-green-400",
    red: "bg-red-400",
    purple: "bg-purple-600",
}

export default BannerStyle